import React from 'react'
import propType from '../DefaultPropTypes'
import Lib from '../../loader'

function Container({ children, className }) {
  return (
    <Lib.Container className={className}>
      { children }
    </Lib.Container>
  )
}

Container.propTypes = {
  ...propType,
}

export default Container
